var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34289 4.2529C6.6915 3.8545 7.31069 3.85451 7.6593 4.2529L11.8566 9.0488C12.3514 9.61446 11.9498 10.4997 11.1984 10.5H2.80481C2.05314 10.5 1.6509 9.61457 2.14563 9.0488L6.34289 4.2529Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFill);
export default __webpack_public_path__ + "static/media/arrow-up-fill.66295d0d1e6950718aca5619f53d0024.svg";
export { ForwardRef as ReactComponent };